import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksVendorFields.FinanceSection', {
    header: 'FINANCE',
    baseCurrency: 'Base Currency',
    businessID: 'Business ID No. / Social security number',
    defaultExpenseAccount: 'Default expense account',
});
